module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-filled.05951ccf.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-filled/fonts/Pe-icon-7-filled.ttf?kinggk
 ** module id = 1602
 ** module chunks = 0
 **/